export type LacTenantCostUsageBarProps = {
  estimatedCosts: number | null | undefined;
  costLimit: number;
  ariaLabel: string;
};

export function LacTenantCostUsageBar({
  estimatedCosts,
  costLimit,
  ariaLabel,
}: LacTenantCostUsageBarProps) {
  const costs =
    estimatedCosts != null && Number.isFinite(estimatedCosts)
      ? Math.max(0, estimatedCosts)
      : 0;
  const usageRatio = costs / costLimit;
  const usagePercent = Math.round(usageRatio * 100);
  const barPercent = Math.min(100, Math.max(0, usageRatio * 100));
  const isExceeded = usageRatio > 1;
  const isWarning = !isExceeded && usageRatio >= 0.8;

  return (
    <div
      className={[
        'lac-tenants__cost-bar',
        isWarning && 'lac-tenants__cost-bar--warning',
        isExceeded && 'lac-tenants__cost-bar--exceeded',
      ]
        .filter(Boolean)
        .join(' ')}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.min(100, Math.max(0, usagePercent))}
      aria-label={ariaLabel}
    >
      <div
        className="lac-tenants__cost-bar-fill"
        style={{ width: `${barPercent}%` }}
      />
    </div>
  );
}
